/**
 * Messages for "Ferramentas de sala" (room tools): sorteio, equipes+placar,
 * desafio do silêncio e timer.
 * pt-BR is the source of truth; en-US / es-ES satisfy the same keys.
 */

export const roomToolsPtBR = {
  raffleCoins: "Moedas do aluno sorteado",
  raffleAction: "Ação",
  raffleAdd: "Conceder moedas",
  raffleRemove: "Retirar moedas",
  raffleAmount: "Quantidade",
  raffleAmountInvalid: "Informe uma quantidade inteira maior que zero.",
  raffleApplied: "Lançamento concluído",
  rewardRecipientsPenaltyOne: "1 aluno perde",
  reasonRafflePenalty: "Sorteio de aluno — desconto na dinâmica",

  // Launcher
  title: "Ferramentas de sala",
  subtitle: "Dinâmicas rápidas para usar durante a aula",
  openAll: "abrir todas",
  chooseAtOpen: "escolher ao abrir",
  footerHint: "Abre pela home ou de dentro da turma",
  close: "Fechar",
  back: "Voltar",
  fullscreenEnter: "Tela cheia",
  fullscreenExit: "Sair da tela cheia",

  // Ferramentas
  raffleName: "Sorteio de aluno",
  raffleDesc: "Quem responde agora?",
  teamsName: "Equipes + Placar",
  teamsDesc: "Divide a turma e pontua",
  silenceName: "Desafio do Silêncio",
  silenceDesc: "Silêncio que vale pontos",
  timerName: "Timer / Cronômetro",
  timerDesc: "Regressivo ou progressivo",

  // Seletor de turmas
  pickerTitle: "Com quais turmas?",
  pickerSearch: "Buscar turma…",
  pickerClear: "Limpar",
  pickerClearSearch: "Limpar busca",
  pickerAll: "Todas as turmas",
  pickerAllDesc: "juntar todo mundo numa dinâmica só",
  pickerContinue: "Continuar",
  pickerEmptySearch: "Nenhuma turma com esse nome",
  pickerSelectAtLeastOne: "Selecione ao menos uma turma",
  pickerMixedSegments: "Turmas de segmentos diferentes: cada aluno recebe conforme o segmento dele.",
  studentCount: "{{count}} alunos",
  studentCountOne: "1 aluno",
  classCount: "{{count}} turmas",
  selectionSummary: "{{label}} · {{students}}",

  // Seleção de alunos (tirar quem faltou antes de lançar)
  studentChipAria: "Ajustar quem está na seleção",
  studentChipPartial: "{{included}} de {{total}} alunos",
  studentPickerTitle: "Quem está na seleção?",
  studentPickerDesc: "Tire quem não está na aula agora. Ninguém de fora entra no sorteio, nas equipes ou no lançamento.",
  studentPickerSearch: "Buscar aluno…",
  studentPickerEmptySearch: "Nenhum aluno com esse nome",
  studentPickerRestoreAll: "Devolver todos",
  studentPickerIncludeAria: "Devolver {{name}} para a seleção",
  studentPickerExcludeAria: "Tirar {{name}} da seleção",
  studentPickerExcludedTag: "De fora",
  studentPickerDone: "Pronto",

  // Estados
  loading: "Carregando…",
  noClassesTitle: "Você ainda não tem turmas",
  noClassesDesc: "Crie uma turma com alunos para usar as ferramentas de sala.",
  noClassesCta: "Criar primeira turma",
  noStudentsTitle: "Nenhum aluno nesta seleção",
  noStudentsDesc: "Escolha outra turma ou adicione alunos para começar.",
  loadErrorTitle: "Não foi possível carregar suas turmas",
  loadErrorCta: "Tentar de novo",
  skippedNoSegment: "{{count}} aluno(s) sem segmento configurado ficaram de fora",
  allExcludedTitle: "Você tirou todo mundo da seleção",
  allExcludedDesc: "Sem alunos selecionados não dá pra lançar nada. Devolva quem deveria participar.",

  // Sorteio
  raffleHint: "Sorteia quem responde agora",
  raffleDraw: "Sortear aluno",
  raffleDrawAgain: "Sortear outro",
  raffleWinnerLabel: "vai responder agora",
  raffleNoRepeat: "Sorteados não repetem até zerar a rodada",
  raffleExhausted: "Todos já foram sorteados",
  raffleRestart: "Reiniciar rodada",
  raffleAward: "Premiar",

  // Equipes
  teamsSetupTitle: "Dividir a turma em equipes",
  teamsSetupDesc: "Escolha quantos grupos. O Gamefik sorteia os alunos de forma equilibrada.",
  teamsHowMany: "Quantos grupos?",
  teamsDraw: "Sortear equipes",
  teamsDrawing: "Sorteando as equipes…",
  teamsRedraw: "Re-sortear",
  teamsRedrawConfirm: "Re-sortear apaga o placar atual. Continuar?",
  teamsUseLast: "Usar a última divisão",
  teamsLastLoaded: "Última divisão carregada",
  teamsLastLoadedDesc: "mesmos grupos da vez passada",
  teamsLastNoneTitle: "Nenhuma divisão anterior",
  teamsLastNoneDesc: "sorteie as equipes primeiro",
  teamsRosterChanged: "A turma mudou desde a última divisão",
  teamsRosterChangedDesc: "{{removed}} saíram e {{added}} entraram. Confira antes de começar.",
  teamsFinish: "Encerrar e premiar",
  teamsTooManyGroups: "Só dá pra fazer {{max}} grupo(s)",
  teamsTooManyGroupsDesc: "a seleção tem {{students}}",
  teamsNeedMoreStudents: "Precisa de pelo menos 2 alunos para montar equipes",
  teamsPodiumTitle: "Resultado final",
  teamsBackToScore: "Voltar ao placar",
  teamsAwardChampion: "Premiar campeão",
  teamsAwardChampions: "Premiar campeões",
  teamsAlreadyAwarded: "Já premiado",
  teamsAlreadyAwardedHint: "Sorteie as equipes de novo para começar uma rodada nova.",
  teamsTie: "Empate: {{count}} equipes no topo",
  teamsTieDesc: "todas as equipes empatadas serão premiadas",
  teamsGroupsOption: "{{count}} grupos",
  teamsAddPoints: "Adicionar {{value}} pontos para {{team}}",
  teamName1: "Time Foguete",
  teamName2: "Time Raio",
  teamName3: "Time Trovão",
  teamName4: "Time Chama",
  teamName5: "Time Onda",
  teamName6: "Time Estrela",

  // Desafio do Silêncio
  silenceSetupTitle: "Desafio do Silêncio",
  silenceSetupDesc: "A turma segura o silêncio pelo tempo escolhido. Conseguiu, ganha pontos. Passou do limite 3 vezes, perde.",
  silenceRuleWin: "Conseguiu",
  silenceRuleUpTo: "até",
  silenceRuleHeartLost: "Cada coração perdido",
  silenceRuleLose: "Perdeu as 3 vidas",
  silenceHowLong: "Por quanto tempo?",
  silenceParticipantsLine: "{{participants}} vão participar do desafio",
  silenceParticipantsAdjust: "Ajustar",
  silenceStart: "Começar desafio",
  silenceMicAutoCalibrates: "O microfone calibra sozinho com o barulho da sala. Você ajusta o limite durante o desafio.",
  silenceUsesSavedLimit: "Começa no limite que você ajustou nesta turma. Dá pra mudar durante o desafio.",
  silenceDeviceTipTitle: "Deixe o aparelho no meio da sala",
  silenceDeviceTip: "Perto de você, o microfone escuta mais a sua voz do que a da turma — e a turma perde coração pelo seu barulho. Se precisar falar, use o botão \"Estou falando\" durante o desafio.",
  silenceThresholdAria: "Limite de ruído",
  silenceThresholdValue: "Limite em {{value}} de 100",
  silenceThresholdHint: "Arraste o limite para ajustar à sua sala",
  silenceTeacherTalking: "Estou falando",
  silenceTeacherTalkingOn: "Voltar a contar",
  silenceNotCounting: "Não estou contando",
  silenceMutedWarning: "Atenção: {{duration}} deste desafio ficaram com a contagem desligada. Nesse tempo o barulho da turma não foi medido.",
  silenceGroupQuick: "Rapidinho",
  silenceGroupActivity: "Durante uma atividade",
  silenceGroupClass: "Aula inteira",
  silenceMinutes: "{{count}} minutos",
  silenceMinuteOne: "1 minuto",
  silenceHourOne: "1 hora",
  silenceHours: "{{count}} horas",
  silenceCalibrating: "Ouvindo a sala…",
  silenceCalibratingDesc: "Calibrando o que é silêncio aqui",
  silenceRecalibrate: "Recalibrar",
  silenceRemaining: "restante",
  silenceLimit: "limite",
  silenceStatusGreat: "Silêncio ótimo",
  silenceStatusClose: "Quase no limite",
  silenceStatusOver: "Passou do limite!",
  silenceLifeLost: "Passou do limite! −1 vida ({{left}} restantes)",
  silenceLifeLostOne: "Passou do limite! −1 vida (1 restante)",
  silenceLastLifeLost: "Última vida perdida",
  silenceLifeLostDesc: "a turma passou do limite de barulho",
  silenceUndoLife: "Foi barulho de fora, devolver vida",
  silenceLifeRestored: "Vida devolvida",
  silencePaused: "Desafio pausado",
  silencePausedTab: "Volte para esta aba para continuar",
  silencePausedMic: "O microfone foi desconectado ou a permissão foi revogada",
  silenceResume: "Continuar",
  silenceStop: "Encerrar",
  silenceWonTitle: "Conseguiram!",
  silenceWonDesc: "{{duration}} de silêncio · {{lives}} restantes",
  silenceLostTitle: "Não foi essa vez",
  silenceLostDesc: "A turma perdeu as 3 vidas do desafio",
  silenceAwardClass: "Premiar turma",
  silenceApplyPenalty: "Lançar penalidade",
  silenceForgive: "Dessa vez passa",
  silenceRetry: "De novo",
  silenceLifeCount: "{{count}} vidas",
  silenceLifeCountOne: "1 vida",
  silenceExitConfirm: "O desafio está em andamento. Sair agora perde o progresso e não lança nada.",

  // Microfone — erros
  micDeniedTitle: "Precisamos do microfone",
  micDeniedDesc: "Libere o acesso ao microfone no ícone de cadeado da barra de endereço e tente de novo.",
  micNotFoundTitle: "Nenhum microfone encontrado",
  micNotFoundDesc: "Conecte um microfone ao computador para usar o Desafio do Silêncio.",
  micUnsupportedTitle: "Navegador sem suporte",
  micUnsupportedDesc: "Este navegador não permite acesso ao microfone. Tente pelo Chrome ou Edge.",
  micInsecureTitle: "Conexão não segura",
  micInsecureDesc: "O acesso ao microfone exige uma conexão segura (https).",
  micRetry: "Tentar de novo",

  // Timer
  timerModeDown: "Regressivo",
  timerModeUp: "Cronômetro",
  timerStart: "Iniciar",
  timerPause: "Pausar",
  timerReset: "Zerar",
  timerDone: "Tempo!",
  timerMinutes: "{{count}} min",
  timerSoundBlocked: "O som pode não ter tocado",
  timerSoundBlockedDesc: "seu navegador bloqueou o áudio",
  timerSwitchConfirm: "O timer está rodando. Trocar agora zera a contagem.",
  timerCustom: "Outro tempo",
  timerCustomLabel: "Tempo personalizado, em minutos",
  timerCustomUnit: "min",
  timerCustomApply: "Usar",
  timerCustomInvalid: "Escolha um tempo de {{min}} a {{max}} minutos",

  // Lançamento
  rewardTitleRaffle: "Premiar quem participou",
  rewardTitleTeams: "Premiar equipe campeã",
  rewardTitleTeamsTie: "Premiar equipes campeãs",
  rewardTitleSilenceWin: "Premiar a turma",
  rewardTitleSilenceLose: "Lançar penalidade",
  rewardSubtitle: "Feedback personalizado · {{tool}}",
  rewardRecipientsOne: "1 aluno recebe",
  rewardRecipients: "{{count}} alunos recebem",
  rewardRecipientsPenalty: "{{count}} alunos perdem",
  rewardValue: "{{value}} moedas",
  rewardCoinsLabel: "moedas",
  rewardFixed: "valor fixo",
  rewardNoteGood: "O aluno recebe no app com o motivo escrito, igual a um feedback personalizado.",
  rewardNoteBad: "O aluno perde moedas e vê o motivo escrito no app.",
  rewardConfirm: "Lançar recompensa",
  rewardConfirmPenalty: "Lançar penalidade",
  rewardCancel: "Cancelar",
  rewardSending: "Lançando…",
  rewardSuccess: "Lançamento feito",
  rewardSuccessDesc: "apareceu no app do aluno com o motivo",
  rewardErrorTitle: "Não foi possível lançar",
  rewardErrorNetwork: "Sem conexão. Tente novamente.",
  rewardRetry: "Tentar de novo",

  // Motivos (o texto que o aluno vê)
  reasonRaffle: "Sorteio de aluno — participou da dinâmica",
  reasonTeams: "Dinâmica em grupo — equipe campeã ({{team}})",
  reasonSilenceWin: "Desafio do Silêncio — turma concentrada ({{duration}}, {{lives}})",
  reasonSilenceLose: "Desafio do Silêncio — passou do limite de barulho",
} as const;

export const roomToolsEnUS = {
  raffleCoins: "Coins for the selected student",
  raffleAction: "Action",
  raffleAdd: "Give coins",
  raffleRemove: "Remove coins",
  raffleAmount: "Amount",
  raffleAmountInvalid: "Enter a whole number greater than zero.",
  raffleApplied: "Adjustment completed",
  rewardRecipientsPenaltyOne: "1 student loses",
  reasonRafflePenalty: "Student picker — deduction during the activity",

  title: "Classroom tools",
  subtitle: "Quick activities to run during class",
  openAll: "open all",
  chooseAtOpen: "choose when opening",
  footerHint: "Opens from the home or from inside a class",
  close: "Close",
  back: "Back",
  fullscreenEnter: "Fullscreen",
  fullscreenExit: "Exit fullscreen",

  raffleName: "Student picker",
  raffleDesc: "Who answers next?",
  teamsName: "Teams + Scoreboard",
  teamsDesc: "Split the class and score",
  silenceName: "Silence Challenge",
  silenceDesc: "Quiet goal with a reward",
  timerName: "Timer / Stopwatch",
  timerDesc: "Countdown or count up",

  pickerTitle: "Which classes?",
  pickerSearch: "Search class…",
  pickerClear: "Clear",
  pickerClearSearch: "Clear search",
  pickerAll: "All classes",
  pickerAllDesc: "bring everyone into a single activity",
  pickerContinue: "Continue",
  pickerEmptySearch: "No class with that name",
  pickerSelectAtLeastOne: "Select at least one class",
  pickerMixedSegments: "Classes from different segments: each student is credited per their own segment.",
  studentCount: "{{count}} students",
  studentCountOne: "1 student",
  classCount: "{{count}} classes",
  selectionSummary: "{{label}} · {{students}}",

  studentChipAria: "Adjust who's in the selection",
  studentChipPartial: "{{included}} of {{total}} students",
  studentPickerTitle: "Who's in the selection?",
  studentPickerDesc: "Remove anyone who isn't in class right now. Nobody outside joins the draw, the teams, or the reward.",
  studentPickerSearch: "Search student…",
  studentPickerEmptySearch: "No student with that name",
  studentPickerRestoreAll: "Bring everyone back",
  studentPickerIncludeAria: "Bring {{name}} back into the selection",
  studentPickerExcludeAria: "Remove {{name}} from the selection",
  studentPickerExcludedTag: "Out",
  studentPickerDone: "Done",

  loading: "Loading…",
  noClassesTitle: "You don't have any classes yet",
  noClassesDesc: "Create a class with students to use the classroom tools.",
  noClassesCta: "Create first class",
  noStudentsTitle: "No students in this selection",
  noStudentsDesc: "Pick another class or add students to get started.",
  loadErrorTitle: "We couldn't load your classes",
  loadErrorCta: "Try again",
  skippedNoSegment: "{{count}} student(s) without a segment were left out",
  allExcludedTitle: "You removed everyone from the selection",
  allExcludedDesc: "With no students selected there's nothing to send. Bring back whoever should take part.",

  raffleHint: "Draws who answers next",
  raffleDraw: "Draw a student",
  raffleDrawAgain: "Draw another",
  raffleWinnerLabel: "answers next",
  raffleNoRepeat: "Picked students don't repeat until the round resets",
  raffleExhausted: "Everyone has been picked",
  raffleRestart: "Restart round",
  raffleAward: "Reward",

  teamsSetupTitle: "Split the class into teams",
  teamsSetupDesc: "Choose how many groups. Gamefik shuffles students evenly.",
  teamsHowMany: "How many groups?",
  teamsDraw: "Draw teams",
  teamsDrawing: "Drawing teams…",
  teamsRedraw: "Redraw",
  teamsRedrawConfirm: "Redrawing clears the current scoreboard. Continue?",
  teamsUseLast: "Use the last split",
  teamsLastLoaded: "Last split loaded",
  teamsLastLoadedDesc: "same groups as last time",
  teamsLastNoneTitle: "No previous split",
  teamsLastNoneDesc: "draw the teams first",
  teamsRosterChanged: "The class changed since the last split",
  teamsRosterChangedDesc: "{{removed}} left and {{added}} joined. Review before starting.",
  teamsFinish: "Finish and reward",
  teamsTooManyGroups: "Only {{max}} group(s) possible",
  teamsTooManyGroupsDesc: "the selection has {{students}}",
  teamsNeedMoreStudents: "You need at least 2 students to build teams",
  teamsPodiumTitle: "Final result",
  teamsBackToScore: "Back to scoreboard",
  teamsAwardChampion: "Reward champion",
  teamsAwardChampions: "Reward champions",
  teamsAlreadyAwarded: "Already rewarded",
  teamsAlreadyAwardedHint: "Draw teams again to start a new round.",
  teamsTie: "Tie: {{count}} teams on top",
  teamsTieDesc: "every tied team will be rewarded",
  teamsGroupsOption: "{{count}} groups",
  teamsAddPoints: "Add {{value}} points to {{team}}",
  teamName1: "Rocket Team",
  teamName2: "Lightning Team",
  teamName3: "Thunder Team",
  teamName4: "Flame Team",
  teamName5: "Wave Team",
  teamName6: "Star Team",

  silenceSetupTitle: "Silence Challenge",
  silenceSetupDesc: "The class keeps quiet for the chosen time. Make it, they earn points. Cross the limit 3 times, they lose.",
  silenceRuleWin: "Made it",
  silenceRuleUpTo: "up to",
  silenceRuleHeartLost: "Each heart lost",
  silenceRuleLose: "Lost all 3 lives",
  silenceHowLong: "For how long?",
  silenceParticipantsLine: "{{participants}} will take part in the challenge",
  silenceParticipantsAdjust: "Adjust",
  silenceStart: "Start challenge",
  silenceMicAutoCalibrates: "The microphone calibrates itself to the room. You adjust the limit during the challenge.",
  silenceUsesSavedLimit: "Starts at the limit you set for this class. You can change it during the challenge.",
  silenceDeviceTipTitle: "Leave the device in the middle of the room",
  silenceDeviceTip: "Close to you, the microphone hears you more than the class — and the class loses hearts for your noise. If you need to speak, use the \"I'm talking\" button during the challenge.",
  silenceThresholdAria: "Noise limit",
  silenceThresholdValue: "Limit at {{value}} of 100",
  silenceThresholdHint: "Drag the limit to fit your room",
  silenceTeacherTalking: "I'm talking",
  silenceTeacherTalkingOn: "Start counting again",
  silenceNotCounting: "Not counting",
  silenceMutedWarning: "Heads up: {{duration}} of this challenge had counting turned off. Class noise was not measured during that time.",
  silenceGroupQuick: "Quick",
  silenceGroupActivity: "During an activity",
  silenceGroupClass: "Whole class",
  silenceMinutes: "{{count}} minutes",
  silenceMinuteOne: "1 minute",
  silenceHourOne: "1 hour",
  silenceHours: "{{count}} hours",
  silenceCalibrating: "Listening to the room…",
  silenceCalibratingDesc: "Calibrating what counts as quiet here",
  silenceRecalibrate: "Recalibrate",
  silenceRemaining: "remaining",
  silenceLimit: "limit",
  silenceStatusGreat: "Nice and quiet",
  silenceStatusClose: "Close to the limit",
  silenceStatusOver: "Over the limit!",
  silenceLifeLost: "Over the limit! −1 life ({{left}} left)",
  silenceLifeLostOne: "Over the limit! −1 life (1 left)",
  silenceLastLifeLost: "Last life lost",
  silenceLifeLostDesc: "the class went over the noise limit",
  silenceUndoLife: "That was outside noise, give the life back",
  silenceLifeRestored: "Life restored",
  silencePaused: "Challenge paused",
  silencePausedTab: "Come back to this tab to continue",
  silencePausedMic: "The microphone was disconnected or permission was revoked",
  silenceResume: "Continue",
  silenceStop: "Stop",
  silenceWonTitle: "They made it!",
  silenceWonDesc: "{{duration}} of quiet · {{lives}} left",
  silenceLostTitle: "Not this time",
  silenceLostDesc: "The class lost all 3 lives",
  silenceAwardClass: "Reward the class",
  silenceApplyPenalty: "Apply penalty",
  silenceForgive: "Let it slide this time",
  silenceRetry: "Again",
  silenceLifeCount: "{{count}} lives",
  silenceLifeCountOne: "1 life",
  silenceExitConfirm: "The challenge is running. Leaving now loses the progress and nothing is applied.",

  micDeniedTitle: "We need the microphone",
  micDeniedDesc: "Allow microphone access from the lock icon in the address bar and try again.",
  micNotFoundTitle: "No microphone found",
  micNotFoundDesc: "Connect a microphone to use the Silence Challenge.",
  micUnsupportedTitle: "Browser not supported",
  micUnsupportedDesc: "This browser doesn't allow microphone access. Try Chrome or Edge.",
  micInsecureTitle: "Insecure connection",
  micInsecureDesc: "Microphone access requires a secure connection (https).",
  micRetry: "Try again",

  timerModeDown: "Countdown",
  timerModeUp: "Stopwatch",
  timerStart: "Start",
  timerPause: "Pause",
  timerReset: "Reset",
  timerDone: "Time!",
  timerMinutes: "{{count}} min",
  timerSoundBlocked: "The sound may not have played",
  timerSoundBlockedDesc: "your browser blocked the audio",
  timerSwitchConfirm: "The timer is running. Switching now resets the count.",
  timerCustom: "Other time",
  timerCustomLabel: "Custom time, in minutes",
  timerCustomUnit: "min",
  timerCustomApply: "Use",
  timerCustomInvalid: "Pick a time between {{min}} and {{max}} minutes",

  rewardTitleRaffle: "Reward who took part",
  rewardTitleTeams: "Reward the winning team",
  rewardTitleTeamsTie: "Reward the winning teams",
  rewardTitleSilenceWin: "Reward the class",
  rewardTitleSilenceLose: "Apply penalty",
  rewardSubtitle: "Custom feedback · {{tool}}",
  rewardRecipientsOne: "1 student receives",
  rewardRecipients: "{{count}} students receive",
  rewardRecipientsPenalty: "{{count}} students lose",
  rewardValue: "{{value}} coins",
  rewardCoinsLabel: "coins",
  rewardFixed: "fixed value",
  rewardNoteGood: "The student gets it in the app with the written reason, just like a custom feedback.",
  rewardNoteBad: "The student loses coins and sees the written reason in the app.",
  rewardConfirm: "Send reward",
  rewardConfirmPenalty: "Apply penalty",
  rewardCancel: "Cancel",
  rewardSending: "Sending…",
  rewardSuccess: "Sent",
  rewardSuccessDesc: "showed up in the student's app with the reason",
  rewardErrorTitle: "Couldn't send",
  rewardErrorNetwork: "No connection. Please try again.",
  rewardRetry: "Try again",

  reasonRaffle: "Student picker — took part in the activity",
  reasonTeams: "Group activity — winning team ({{team}})",
  reasonSilenceWin: "Silence Challenge — focused class ({{duration}}, {{lives}})",
  reasonSilenceLose: "Silence Challenge — went over the noise limit",
} as const;

export const roomToolsEsES = {
  raffleCoins: "Monedas del alumno sorteado",
  raffleAction: "Acción",
  raffleAdd: "Conceder monedas",
  raffleRemove: "Retirar monedas",
  raffleAmount: "Cantidad",
  raffleAmountInvalid: "Introduce una cantidad entera mayor que cero.",
  raffleApplied: "Ajuste completado",
  rewardRecipientsPenaltyOne: "1 alumno pierde",
  reasonRafflePenalty: "Sorteo de alumno — descuento en la dinámica",

  title: "Herramientas de clase",
  subtitle: "Dinámicas rápidas para usar durante la clase",
  openAll: "abrir todas",
  chooseAtOpen: "elegir al abrir",
  footerHint: "Se abre desde el inicio o desde dentro de la clase",
  close: "Cerrar",
  back: "Volver",
  fullscreenEnter: "Pantalla completa",
  fullscreenExit: "Salir de pantalla completa",

  raffleName: "Sorteo de alumno",
  raffleDesc: "¿Quién responde ahora?",
  teamsName: "Equipos + Marcador",
  teamsDesc: "Divide la clase y puntúa",
  silenceName: "Desafío del Silencio",
  silenceDesc: "Silencio que vale puntos",
  timerName: "Temporizador / Cronómetro",
  timerDesc: "Regresivo o progresivo",

  pickerTitle: "¿Con qué clases?",
  pickerSearch: "Buscar clase…",
  pickerClear: "Limpiar",
  pickerClearSearch: "Limpiar búsqueda",
  pickerAll: "Todas las clases",
  pickerAllDesc: "juntar a todos en una sola dinámica",
  pickerContinue: "Continuar",
  pickerEmptySearch: "Ninguna clase con ese nombre",
  pickerSelectAtLeastOne: "Selecciona al menos una clase",
  pickerMixedSegments: "Clases de segmentos distintos: cada alumno recibe según su propio segmento.",
  studentCount: "{{count}} alumnos",
  studentCountOne: "1 alumno",
  classCount: "{{count}} clases",
  selectionSummary: "{{label}} · {{students}}",

  studentChipAria: "Ajustar quién está en la selección",
  studentChipPartial: "{{included}} de {{total}} alumnos",
  studentPickerTitle: "¿Quién está en la selección?",
  studentPickerDesc: "Quita a quien no esté en clase ahora. Nadie de fuera participa en el sorteo, los equipos ni el lanzamiento.",
  studentPickerSearch: "Buscar alumno…",
  studentPickerEmptySearch: "Ningún alumno con ese nombre",
  studentPickerRestoreAll: "Devolver a todos",
  studentPickerIncludeAria: "Devolver a {{name}} a la selección",
  studentPickerExcludeAria: "Quitar a {{name}} de la selección",
  studentPickerExcludedTag: "Fuera",
  studentPickerDone: "Listo",

  loading: "Cargando…",
  noClassesTitle: "Todavía no tienes clases",
  noClassesDesc: "Crea una clase con alumnos para usar las herramientas de clase.",
  noClassesCta: "Crear primera clase",
  noStudentsTitle: "Ningún alumno en esta selección",
  noStudentsDesc: "Elige otra clase o añade alumnos para empezar.",
  loadErrorTitle: "No pudimos cargar tus clases",
  loadErrorCta: "Reintentar",
  skippedNoSegment: "{{count}} alumno(s) sin segmento quedaron fuera",
  allExcludedTitle: "Quitaste a todos de la selección",
  allExcludedDesc: "Sin alumnos seleccionados no hay nada que lanzar. Devuelve a quien deba participar.",

  raffleHint: "Sortea quién responde ahora",
  raffleDraw: "Sortear alumno",
  raffleDrawAgain: "Sortear otro",
  raffleWinnerLabel: "responde ahora",
  raffleNoRepeat: "Los sorteados no se repiten hasta reiniciar la ronda",
  raffleExhausted: "Ya salieron todos",
  raffleRestart: "Reiniciar ronda",
  raffleAward: "Premiar",

  teamsSetupTitle: "Dividir la clase en equipos",
  teamsSetupDesc: "Elige cuántos grupos. Gamefik reparte a los alumnos de forma equilibrada.",
  teamsHowMany: "¿Cuántos grupos?",
  teamsDraw: "Sortear equipos",
  teamsDrawing: "Sorteando los equipos…",
  teamsRedraw: "Volver a sortear",
  teamsRedrawConfirm: "Volver a sortear borra el marcador actual. ¿Continuar?",
  teamsUseLast: "Usar la última división",
  teamsLastLoaded: "Última división cargada",
  teamsLastLoadedDesc: "mismos grupos que la vez pasada",
  teamsLastNoneTitle: "No hay división anterior",
  teamsLastNoneDesc: "sortea los equipos primero",
  teamsRosterChanged: "La clase cambió desde la última división",
  teamsRosterChangedDesc: "{{removed}} salieron y {{added}} entraron. Revisa antes de empezar.",
  teamsFinish: "Terminar y premiar",
  teamsTooManyGroups: "Solo se pueden hacer {{max}} grupo(s)",
  teamsTooManyGroupsDesc: "la selección tiene {{students}}",
  teamsNeedMoreStudents: "Necesitas al menos 2 alumnos para armar equipos",
  teamsPodiumTitle: "Resultado final",
  teamsBackToScore: "Volver al marcador",
  teamsAwardChampion: "Premiar campeón",
  teamsAwardChampions: "Premiar campeones",
  teamsAlreadyAwarded: "Ya premiado",
  teamsAlreadyAwardedHint: "Sortea los equipos de nuevo para empezar una ronda nueva.",
  teamsTie: "Empate: {{count}} equipos arriba",
  teamsTieDesc: "todos los equipos empatados serán premiados",
  teamsGroupsOption: "{{count}} grupos",
  teamsAddPoints: "Añadir {{value}} puntos a {{team}}",
  teamName1: "Equipo Cohete",
  teamName2: "Equipo Rayo",
  teamName3: "Equipo Trueno",
  teamName4: "Equipo Llama",
  teamName5: "Equipo Ola",
  teamName6: "Equipo Estrella",

  silenceSetupTitle: "Desafío del Silencio",
  silenceSetupDesc: "La clase mantiene el silencio durante el tiempo elegido. Si lo logra, gana puntos. Si pasa del límite 3 veces, pierde.",
  silenceRuleWin: "Lo lograron",
  silenceRuleUpTo: "hasta",
  silenceRuleHeartLost: "Cada corazón perdido",
  silenceRuleLose: "Perdieron las 3 vidas",
  silenceHowLong: "¿Por cuánto tiempo?",
  silenceParticipantsLine: "{{participants}} van a participar en el desafío",
  silenceParticipantsAdjust: "Ajustar",
  silenceStart: "Empezar desafío",
  silenceMicAutoCalibrates: "El micrófono se calibra solo con el ruido del aula. El límite lo ajustas durante el desafío.",
  silenceUsesSavedLimit: "Empieza en el límite que ajustaste en esta clase. Puedes cambiarlo durante el desafío.",
  silenceDeviceTipTitle: "Deja el dispositivo en medio del aula",
  silenceDeviceTip: "Cerca de ti, el micrófono escucha más tu voz que la de la clase — y la clase pierde corazones por tu ruido. Si necesitas hablar, usa el botón \"Estoy hablando\" durante el desafío.",
  silenceThresholdAria: "Límite de ruido",
  silenceThresholdValue: "Límite en {{value}} de 100",
  silenceThresholdHint: "Arrastra el límite para ajustarlo a tu aula",
  silenceTeacherTalking: "Estoy hablando",
  silenceTeacherTalkingOn: "Volver a contar",
  silenceNotCounting: "No estoy contando",
  silenceMutedWarning: "Atención: {{duration}} de este desafío tuvieron el conteo apagado. En ese tiempo no se midió el ruido de la clase.",
  silenceGroupQuick: "Rapidito",
  silenceGroupActivity: "Durante una actividad",
  silenceGroupClass: "Clase entera",
  silenceMinutes: "{{count}} minutos",
  silenceMinuteOne: "1 minuto",
  silenceHourOne: "1 hora",
  silenceHours: "{{count}} horas",
  silenceCalibrating: "Escuchando el aula…",
  silenceCalibratingDesc: "Calibrando qué es silencio aquí",
  silenceRecalibrate: "Recalibrar",
  silenceRemaining: "restante",
  silenceLimit: "límite",
  silenceStatusGreat: "Silencio perfecto",
  silenceStatusClose: "Casi en el límite",
  silenceStatusOver: "¡Pasó del límite!",
  silenceLifeLost: "¡Pasó del límite! −1 vida ({{left}} restantes)",
  silenceLifeLostOne: "¡Pasó del límite! −1 vida (1 restante)",
  silenceLastLifeLost: "Última vida perdida",
  silenceLifeLostDesc: "la clase pasó del límite de ruido",
  silenceUndoLife: "Fue ruido de fuera, devolver la vida",
  silenceLifeRestored: "Vida devuelta",
  silencePaused: "Desafío pausado",
  silencePausedTab: "Vuelve a esta pestaña para continuar",
  silencePausedMic: "El micrófono se desconectó o se revocó el permiso",
  silenceResume: "Continuar",
  silenceStop: "Terminar",
  silenceWonTitle: "¡Lo lograron!",
  silenceWonDesc: "{{duration}} de silencio · {{lives}} restantes",
  silenceLostTitle: "No fue esta vez",
  silenceLostDesc: "La clase perdió las 3 vidas del desafío",
  silenceAwardClass: "Premiar a la clase",
  silenceApplyPenalty: "Aplicar penalización",
  silenceForgive: "Esta vez pasa",
  silenceRetry: "Otra vez",
  silenceLifeCount: "{{count}} vidas",
  silenceLifeCountOne: "1 vida",
  silenceExitConfirm: "El desafío está en marcha. Salir ahora pierde el progreso y no se aplica nada.",

  micDeniedTitle: "Necesitamos el micrófono",
  micDeniedDesc: "Permite el acceso al micrófono en el icono del candado de la barra de direcciones e inténtalo de nuevo.",
  micNotFoundTitle: "No se encontró ningún micrófono",
  micNotFoundDesc: "Conecta un micrófono para usar el Desafío del Silencio.",
  micUnsupportedTitle: "Navegador sin soporte",
  micUnsupportedDesc: "Este navegador no permite el acceso al micrófono. Prueba con Chrome o Edge.",
  micInsecureTitle: "Conexión no segura",
  micInsecureDesc: "El acceso al micrófono requiere una conexión segura (https).",
  micRetry: "Reintentar",

  timerModeDown: "Regresivo",
  timerModeUp: "Cronómetro",
  timerStart: "Iniciar",
  timerPause: "Pausar",
  timerReset: "Reiniciar",
  timerDone: "¡Tiempo!",
  timerMinutes: "{{count}} min",
  timerSoundBlocked: "Puede que el sonido no haya sonado",
  timerSoundBlockedDesc: "tu navegador bloqueó el audio",
  timerSwitchConfirm: "El temporizador está corriendo. Cambiar ahora reinicia la cuenta.",
  timerCustom: "Otro tiempo",
  timerCustomLabel: "Tiempo personalizado, en minutos",
  timerCustomUnit: "min",
  timerCustomApply: "Usar",
  timerCustomInvalid: "Elige un tiempo de {{min}} a {{max}} minutos",

  rewardTitleRaffle: "Premiar a quien participó",
  rewardTitleTeams: "Premiar al equipo campeón",
  rewardTitleTeamsTie: "Premiar a los equipos campeones",
  rewardTitleSilenceWin: "Premiar a la clase",
  rewardTitleSilenceLose: "Aplicar penalización",
  rewardSubtitle: "Feedback personalizado · {{tool}}",
  rewardRecipientsOne: "1 alumno recibe",
  rewardRecipients: "{{count}} alumnos reciben",
  rewardRecipientsPenalty: "{{count}} alumnos pierden",
  rewardValue: "{{value}} monedas",
  rewardCoinsLabel: "monedas",
  rewardFixed: "valor fijo",
  rewardNoteGood: "El alumno lo recibe en la app con el motivo escrito, igual que un feedback personalizado.",
  rewardNoteBad: "El alumno pierde monedas y ve el motivo escrito en la app.",
  rewardConfirm: "Enviar recompensa",
  rewardConfirmPenalty: "Aplicar penalización",
  rewardCancel: "Cancelar",
  rewardSending: "Enviando…",
  rewardSuccess: "Enviado",
  rewardSuccessDesc: "apareció en la app del alumno con el motivo",
  rewardErrorTitle: "No se pudo enviar",
  rewardErrorNetwork: "Sin conexión. Inténtalo de nuevo.",
  rewardRetry: "Reintentar",

  reasonRaffle: "Sorteo de alumno — participó en la dinámica",
  reasonTeams: "Dinámica en grupo — equipo campeón ({{team}})",
  reasonSilenceWin: "Desafío del Silencio — clase concentrada ({{duration}}, {{lives}})",
  reasonSilenceLose: "Desafío del Silencio — pasó del límite de ruido",
} as const;
